// Phase 999.4 Plan 05 — Shared API base resolver for admin portal components.
//
// Mirrors the inline helper previously embedded in UserLogViewer.js (lines 60-72).
// Centralised so SitesTable / SiteConfigView / CreateSiteWizard (Plans 06-07)
// don't copy-paste it. window._env_ is the runtime config injected by the host
// (matches the pattern in Home.js); fall back to relative path so unit tests
// can stub fetch without needing the env shim.

export function apiBase() {
    if (typeof window !== 'undefined' && window._env_ && window._env_.REACT_APP_API_ADDRESS) {
        return window._env_.REACT_APP_API_ADDRESS;
    }
    return '';
}

export default apiBase;
